import {
  ApolloClient,
  ApolloLink,
  defaultDataIdFromObject,
  HttpLink,
  InMemoryCache,
} from "@apollo/client"
import { onError } from "@apollo/client/link/error"
import { AUTHENTICATION_CHECKS } from "components/Molecules/Authentication"
import { useHost } from "../global/host.global"
import AppToaster from "utils/AppToaster"
import resolvers from "./resolvers"
import typeDefs from "./typeDefs"
import typePolicies from "./typePolicies"

const useClient = () => {
  // Environment Setting
  const { subdomain, token } = useHost()

  return new ApolloClient({
    link: ApolloLink.from([
      // Error Link
      onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors)
          graphQLErrors.forEach(({ message }) => {
            AUTHENTICATION_CHECKS.forEach(ac => {
              if (ac.code.includes(message)) {
                AppToaster.show({
                  message: ac.message,
                  icon: ac.icon,
                  intent: "danger",
                  timeout: 3000,
                })
                localStorage.clear()
                window.location = "/" as any
                return
              }
            })
          })
        if (networkError) console.error(`[Network error]: ${networkError}`)
      }),
      // HTTP Link
      ApolloLink.split(
        operation => operation.getContext().client === "kite",
        new HttpLink({
          uri: process.env.REACT_APP_KITE_API_URL,
          headers: {
            // login token
            authorization: `Bearer ${process.env.REACT_APP_KITE_API_JWT}`,
          },
        }),
        ApolloLink.split(
          operation => operation.getContext().client === "eagle",
          new HttpLink({
            uri: process.env.REACT_APP_EAGLE_API_URL,
            headers: {
              // data fetch
              authorization: token ? `Bearer ${token}` : undefined,
              "x-hasura-role": "manager",
            },
          }),
          new HttpLink({
            uri: process.env.REACT_APP_API_URL,
            headers: {
              authorization: token ? `Bearer ${token}` : undefined,
              tenant: subdomain,
            },
          })
        )
        // new HttpLink({
        //   uri: process.env.REACT_APP_API_URL,
        //   headers: {
        //     authorization: token ? `Bearer ${token}` : undefined,
        //     tenant: subdomain,
        //   },
        // })
      ),
    ]),
    cache: new InMemoryCache({
      typePolicies,
      dataIdFromObject(responseObject) {
        switch (responseObject.__typename) {
          case "CommonAccountType":
            return `AccountType:${responseObject.id}`
          case "AccountType":
            return `AccountType:${responseObject.id}`
          default:
            return defaultDataIdFromObject(responseObject)
        }
      },
    }),
    resolvers,
    typeDefs,
  })
}

export default useClient
